<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <h4 class="modal-title wrap-text-in">Candidates Present In '{{modalData.stepName}}' Step</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <p [innerHTML]="modalData.message">
            </p>
        </div>
        <div class="col-xs-12 text-right">
            <div class="clearfix">
                <button type="button" class="btn btn-primary" (click)="closeModal()">OK</button>
            </div>
        </div>
    </div>
</div>
